function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEqGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ddb23f70-17bf-47ee-a425-0afbba344446",
    preserveAspectRatio: "none",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 300,
    viewBox: "0 0 960 300.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    x2: 42.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.5,
    x2: 74.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.6,
    x2: 103.6,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.6,
    x2: 125.6,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.5,
    x2: 145.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 163.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    x2: 177.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.5,
    x2: 280.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.5,
    x2: 340.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.5,
    x2: 382.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.5,
    x2: 414.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.5,
    x2: 442.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.5,
    x2: 465.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.5,
    x2: 485.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.5,
    x2: 501.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 517.5,
    x2: 517.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.5,
    x2: 619.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 678.59998,
    x2: 678.59998,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 722.5,
    x2: 722.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 754.5,
    x2: 754.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.5,
    x2: 780.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 805.5,
    x2: 805.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 823.5,
    x2: 823.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 841.5,
    x2: 841.5,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 857.59998,
    x2: 857.59998,
    y2: 299.99999,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 33.5,
    x2: 960,
    y2: 33.5,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 94.7,
    x2: 960,
    y2: 94.7,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 152.70001,
    x2: 960,
    y2: 152.70001,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 212.6,
    x2: 960,
    y2: 212.6,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 273.70001,
    x2: 960,
    y2: 273.70001,
    style: {
      fill: "none",
      stroke: "#282828",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.05859,143.46133a4.95763,4.95763,0,0,1-.65039,2.83008,2.31306,2.31306,0,0,1-2.0332.92578,2.32994,2.32994,0,0,1-2.02148-.90528,4.70549,4.70549,0,0,1-.67969-2.7041v-1.44726a4.84726,4.84726,0,0,1,.65039-2.79492,2.33089,2.33089,0,0,1,2.03906-.91407,2.35219,2.35219,0,0,1,2.02734.88184,4.67785,4.67785,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97185,3.97185,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31355,1.31355,0,0,0-1.21289.627,3.87813,3.87813,0,0,0-.39258,1.92774v1.73437a4.0356,4.0356,0,0,0,.40137,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31033,1.31033,0,0,0,1.19238-.62109,3.88962,3.88962,0,0,0,.40723-1.957Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.96289,80.56289v.91992h-.19922a2.85412,2.85412,0,0,0-2.01562.75,3.12086,3.12086,0,0,0-.86719,2.04492,2.31377,2.31377,0,0,1,1.83984-.77343,2.21235,2.21235,0,0,1,1.77832.78515,3.44086,3.44086,0,0,1-.05273,4.13672,2.47154,2.47154,0,0,1-1.92481.791,2.4352,2.4352,0,0,1-1.98632-.94043,3.72718,3.72718,0,0,1-.76172-2.42285v-.416a5.61614,5.61614,0,0,1,1.00488-3.60059,3.69061,3.69061,0,0,1,2.99121-1.27441Zm-1.42383,3.84375a1.82187,1.82187,0,0,0-1.67578,1.17188V85.977a2.79857,2.79857,0,0,0,.47461,1.69922,1.42226,1.42226,0,0,0,1.18359.64453,1.37813,1.37813,0,0,0,1.15137-.53906,2.589,2.589,0,0,0-.00586-2.833A1.36164,1.36164,0,0,0,24.53906,84.40664Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.07617,203.91836H15.2168v-.88477h2.85937Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.24414,198.56289v.91992h-.19922a2.85412,2.85412,0,0,0-2.01562.75,3.12086,3.12086,0,0,0-.86719,2.04492,2.31377,2.31377,0,0,1,1.83984-.77343,2.21235,2.21235,0,0,1,1.77832.78515,3.44086,3.44086,0,0,1-.05273,4.13672,2.47154,2.47154,0,0,1-1.92481.791,2.4352,2.4352,0,0,1-1.98632-.94043,3.72718,3.72718,0,0,1-.76172-2.42285v-.416a5.61614,5.61614,0,0,1,1.00488-3.60059,3.69061,3.69061,0,0,1,2.99121-1.27441Zm-1.42383,3.84375a1.82187,1.82187,0,0,0-1.67578,1.17188v.39843a2.79857,2.79857,0,0,0,.47461,1.69922,1.42226,1.42226,0,0,0,1.18359.64453,1.37813,1.37813,0,0,0,1.15137-.53906,2.589,2.589,0,0,0-.00586-2.833A1.36164,1.36164,0,0,0,24.82031,202.40664Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.27148,28.1H18.18164V20.87539l-2.18555.80274v-.98438l3.10547-1.166h.16992Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.03711,28.1H22.44727v-.7793l2.95312-3.28125a7.01524,7.01524,0,0,0,.90527-1.21,2.01932,2.01932,0,0,0,.249-.96386,1.53074,1.53074,0,0,0-.4043-1.09571,1.41364,1.41364,0,0,0-1.07812-.42773,1.67418,1.67418,0,0,0-1.25684.46,1.75692,1.75692,0,0,0-.44824,1.28027h-1.084a2.51622,2.51622,0,0,1,.75879-1.90429,2.81292,2.81292,0,0,1,2.03028-.72657,2.70288,2.70288,0,0,1,1.88085.624,2.12855,2.12855,0,0,1,.69141,1.66113,4.8802,4.8802,0,0,1-1.60547,3l-2.28515,2.47851h4.2832Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.07617,264.91836H9.2168v-.88477h2.85937Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.55273,268.1H18.46289v-7.22461l-2.18555.80274v-.98438l3.10547-1.166h.16992Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.31836,268.1H22.72852v-.7793l2.95312-3.28125a7.01524,7.01524,0,0,0,.90527-1.21,2.01932,2.01932,0,0,0,.249-.96386,1.53074,1.53074,0,0,0-.4043-1.09571,1.41364,1.41364,0,0,0-1.07812-.42773,1.67418,1.67418,0,0,0-1.25684.46,1.75692,1.75692,0,0,0-.44824,1.28027h-1.084a2.51622,2.51622,0,0,1,.75879-1.90429,2.81292,2.81292,0,0,1,2.03028-.72657,2.70293,2.70293,0,0,1,1.88086.624,2.12858,2.12858,0,0,1,.6914,1.66113,4.88025,4.88025,0,0,1-1.60547,3l-2.28515,2.47851h4.2832Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.27148,291.1h-1.08984v-7.22461l-2.18555.80274v-.98438l3.10547-1.166h.16992Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.79688,287.46133a4.95762,4.95762,0,0,1-.6504,2.83008,2.70252,2.70252,0,0,1-4.05468.0205,4.70549,4.70549,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97185,3.97185,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87835,3.87835,0,0,0-.39258,1.92774v1.73437a4.0356,4.0356,0,0,0,.40137,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31033,1.31033,0,0,0,1.19238-.62109,3.88962,3.88962,0,0,0,.40723-1.957Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.53516,287.46133a4.95771,4.95771,0,0,1-.65039,2.83008,2.70253,2.70253,0,0,1-4.05469.0205,4.70557,4.70557,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97174,3.97174,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87826,3.87826,0,0,0-.39257,1.92774v1.73437a4.03562,4.03562,0,0,0,.40136,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31035,1.31035,0,0,0,1.19239-.62109,3.88974,3.88974,0,0,0,.40722-1.957Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.27148,291.1h-1.08984v-7.22461l-2.18555.80274v-.98438l3.10547-1.166h.16992Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.79688,287.46133a4.95762,4.95762,0,0,1-.6504,2.83008,2.70252,2.70252,0,0,1-4.05468.0205,4.70549,4.70549,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97185,3.97185,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87835,3.87835,0,0,0-.39258,1.92774v1.73437a4.0356,4.0356,0,0,0,.40137,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31033,1.31033,0,0,0,1.19238-.62109,3.88962,3.88962,0,0,0,.40723-1.957Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.53516,287.46133a4.95771,4.95771,0,0,1-.65039,2.83008,2.70253,2.70253,0,0,1-4.05469.0205,4.70557,4.70557,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97174,3.97174,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87826,3.87826,0,0,0-.39257,1.92774v1.73437a4.03562,4.03562,0,0,0,.40136,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31035,1.31035,0,0,0,1.19239-.62109,3.88974,3.88974,0,0,0,.40722-1.957Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.27344,287.46133a4.95771,4.95771,0,0,1-.65039,2.83008,2.70253,2.70253,0,0,1-4.05469.0205,4.70557,4.70557,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97174,3.97174,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87826,3.87826,0,0,0-.39257,1.92774v1.73437a4.03572,4.03572,0,0,0,.40136,2.042,1.32855,1.32855,0,0,0,1.21582.65918,1.31035,1.31035,0,0,0,1.19239-.62109,3.88974,3.88974,0,0,0,.40722-1.957Z",
    style: {
      fill: "#282828"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.27148,291.1h-1.08984v-7.22461l-2.18555.80274v-.98438l3.10547-1.166h.16992Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.79688,287.46133a4.95762,4.95762,0,0,1-.6504,2.83008,2.70252,2.70252,0,0,1-4.05468.0205,4.70549,4.70549,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97185,3.97185,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87835,3.87835,0,0,0-.39258,1.92774v1.73437a4.0356,4.0356,0,0,0,.40137,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31033,1.31033,0,0,0,1.19238-.62109,3.88962,3.88962,0,0,0,.40723-1.957Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.53516,287.46133a4.95771,4.95771,0,0,1-.65039,2.83008,2.70253,2.70253,0,0,1-4.05469.0205,4.70557,4.70557,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97174,3.97174,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87826,3.87826,0,0,0-.39257,1.92774v1.73437a4.03562,4.03562,0,0,0,.40136,2.042,1.32854,1.32854,0,0,0,1.21582.65918,1.31035,1.31035,0,0,0,1.19239-.62109,3.88974,3.88974,0,0,0,.40722-1.957Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.27344,287.46133a4.95771,4.95771,0,0,1-.65039,2.83008,2.70253,2.70253,0,0,1-4.05469.0205,4.70557,4.70557,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97174,3.97174,0,0,0-.38672-2.00684,1.33109,1.33109,0,0,0-1.22461-.62988,1.31356,1.31356,0,0,0-1.21289.62695,3.87826,3.87826,0,0,0-.39257,1.92774v1.73437a4.03572,4.03572,0,0,0,.40136,2.042,1.32855,1.32855,0,0,0,1.21582.65918,1.31035,1.31035,0,0,0,1.19239-.62109,3.88974,3.88974,0,0,0,.40722-1.957Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.01172,287.46133a4.95771,4.95771,0,0,1-.65039,2.83008,2.70253,2.70253,0,0,1-4.05469.0205,4.70557,4.70557,0,0,1-.67969-2.7041v-1.44726a4.84734,4.84734,0,0,1,.65039-2.79492,2.75107,2.75107,0,0,1,4.06641-.03223,4.678,4.678,0,0,1,.668,2.72168Zm-1.084-1.48242a3.97187,3.97187,0,0,0-.38671-2.00684,1.33111,1.33111,0,0,0-1.22461-.62988,1.31354,1.31354,0,0,0-1.21289.62695,3.87813,3.87813,0,0,0-.39258,1.92774v1.73437a4.03572,4.03572,0,0,0,.40136,2.042,1.32855,1.32855,0,0,0,1.21582.65918,1.31035,1.31035,0,0,0,1.19239-.62109,3.88963,3.88963,0,0,0,.40722-1.957Z",
    style: {
      fill: "#282828"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqGrid);
export default __webpack_public_path__ + "static/media/EqGrid.8d55849b.svg";
export { ForwardRef as ReactComponent };